/* Yummy Gummy — Home (LW-style) behaviour: scroll reveal, tabs, carousel arrows.
   Safe & idempotent; re-inits in the theme editor. */
(function () {
  'use strict';

  function reveals(root) {
    var els = (root || document).querySelectorAll('[data-yg-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function scrollBar(root) {
    (root || document).querySelectorAll('[data-yg-scrollbar]').forEach(function (el) {
      if (el.__ygScroll) return;
      el.__ygScroll = true;
      var track = el.querySelector('[data-yg-scrollbar-track]');
      var set = track ? track.querySelector('[data-yg-scrollbar-set]') : null;
      if (!track || !set) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;
      // The marquee runs at every width now. data-yg-scrollbar-static used to
      // stop it below 768px and leave a swipeable row instead, on the reasoning
      // that a phone can drag. But it reads as broken: the strip sits frozen
      // mid-item with the rest cut off at the edge, giving no sign there is
      // anything to drag towards. Drifting tells the reader by itself, and the
      // row stays draggable underneath for anyone who wants to get ahead of it.
      //
      // The attribute is still honoured under reduced motion, above, where the
      // swipeable row is the right answer rather than a silent stop.

      var setWidth = 0, position = 0, last = null, visible = true;
      function measure() { setWidth = set.getBoundingClientRect().width; }
      // Seamless loop for ANY item count: the content after the first set must cover
      // the container, else a gap appears when the first set scrolls off. Clone the
      // set (aria-hidden) until the track is at least container + one set wide.
      function ensureFill() {
        measure();
        if (setWidth <= 0) return;
        var containerW = el.getBoundingClientRect().width;
        var guard = 0;
        while (track.getBoundingClientRect().width < containerW + setWidth + 1 && guard < 40) {
          var clone = set.cloneNode(true);
          clone.removeAttribute('data-yg-scrollbar-set');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          guard++;
        }
      }
      ensureFill();
      if ('ResizeObserver' in window) { new ResizeObserver(function () { measure(); }).observe(set); }
      window.addEventListener('resize', ensureFill);
      function speed() { return window.innerWidth > 768 ? 60 : 40; }
      function tick(now) {
        if (visible && last !== null) {
          var dt = now - last;
          position += speed() * dt / 1000;
          if (setWidth > 0) position = position % setWidth;
          track.style.transform = 'translateX(' + (-position) + 'px)';
        }
        last = now;
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(el);
      }
    });
  }

  function tabs(root) {
    (root || document).querySelectorAll('[data-yg-tabs]').forEach(function (group) {
      if (group.__ygTabs) return; group.__ygTabs = true;
      var btns = group.querySelectorAll('.yg-lw-tab');
      var panels = group.querySelectorAll('[data-yg-panel]');
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
          panels.forEach(function (p, j) { p.hidden = j !== i; });
        });
      });
    });
  }

  function carousels(root) {
    (root || document).querySelectorAll('[data-yg-carousel]').forEach(function (sec) {
      if (sec.__ygCar) return; sec.__ygCar = true;
      var rail = sec.querySelector('.yg-lw__rail');
      var prev = sec.querySelector('[data-yg-prev]');
      var next = sec.querySelector('[data-yg-next]');
      if (!rail) return;
      function step() { var card = rail.firstElementChild; return card ? card.getBoundingClientRect().width + 16 : 300; }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 1.2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 1.2, behavior: 'smooth' }); });
    });
  }

  function announceBar(root) {
    (root || document).querySelectorAll('[data-yg-ann]').forEach(function (bar) {
      if (bar.__ygAnn) return; bar.__ygAnn = true;
      var msgs = bar.querySelectorAll('.yg-lw-hd__ann-msg');
      if (!msgs.length) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = (parseFloat(bar.getAttribute('data-yg-ann-interval')) || 4) * 1000;
      var i = 0, timer, resetTimer, paused = false;

      function show(nextIndex) {
        var nextI = (nextIndex + msgs.length) % msgs.length;
        if (nextI === i) return;
        var current = msgs[i];
        var next = msgs[nextI];
        current.classList.remove('is-on');
        current.classList.add('is-out');
        next.classList.add('is-on');
        i = nextI;
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () { current.classList.remove('is-out'); }, 550);
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (msgs.length > 1 && !reduceMotion && !paused) {
          timer = setInterval(function () { show(i + 1); }, interval);
        }
      }

      var prev = bar.querySelector('[data-yg-ann-prev]');
      var next = bar.querySelector('[data-yg-ann-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(i + 1); restart(); });
      bar.addEventListener('mouseenter', function () { paused = true; restart(); });
      bar.addEventListener('mouseleave', function () { paused = false; restart(); });
      bar.addEventListener('focusin', function () { paused = true; restart(); });
      bar.addEventListener('focusout', function () { paused = false; restart(); });
      restart();
    });
  }

  /* Smart sticky header — scroll DIRECTION (not raw scroll position)
     decides which of announcement-bar/nav shows, same core comparison
     confirmed from lovewellness.com's own theme-5e275723.js.download
     (compare scrollY against its previous value each scroll event). Their
     OWN real behaviour, confirmed from source, keeps the announcement bar
     ALWAYS visible and only ever toggles the nav — this build deliberately
     does something different, per explicit request: the two SWAP instead
     of one staying constant. Scrolling down shows the announcement bar
     ONLY (nav hidden); scrolling up shows the nav ONLY (announcement bar
     hidden); at/near the very top (within revealAt, the announcement bar's
     own height) both show normally, matching the at-rest state before any
     directional scroll has happened. Also toggles the matching
     body.yg-hd-nav-hidden/yg-hd-ann-hidden classes in the same listener
     (not a second one) — .yg-lw-hd is position:fixed (see assets/
     yg-home.css's own comment for why), which takes it out of normal page
     flow, so #MainContent needs these classes to know which of the three
     padding-top amounts currently applies. */
  function stickyHeader(root) {
    (root || document).querySelectorAll('.yg-lw-hd').forEach(function (header) {
      if (header.__ygSticky) return; header.__ygSticky = true;
      var ann = header.querySelector('.yg-lw-hd__ann');
      var revealAt = ann ? ann.offsetHeight : 0;
      var lastY = window.scrollY;
      var ticking = false;
      function setState(navHidden, annHidden, mobileFloating) {
        header.classList.toggle('is-nav-hidden', navHidden);
        header.classList.toggle('is-ann-hidden', annHidden);
        header.classList.toggle('is-mobile-floating', !!mobileFloating);
        document.body.classList.toggle('yg-hd-nav-hidden', navHidden);
        document.body.classList.toggle('yg-hd-ann-hidden', annHidden);
      }
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          var isMobile = window.innerWidth <= 768;

          /* Ignore tiny movements, and freeze the state entirely at the very
             bottom of the page. Both guard the same feedback loop: hiding the
             nav shortens the document, and at the bottom the browser has to
             pull scrollY back to compensate. That looks like an upward scroll,
             which re-shows the nav, which lengthens the document again — the
             header visibly flickered for as long as you kept scrolling down
             against the end of the page. A threshold larger than that
             compensation breaks the cycle without affecting real scrolling. */
          var atBottom = (window.innerHeight + y) >= (document.documentElement.scrollHeight - 2);
          if (atBottom || Math.abs(y - lastY) < 8) {
            lastY = y;
            ticking = false;
            return;
          }

          if (y <= revealAt) {
            // At/near the top: both the announcement bar and nav show.
            setState(false, false, false);
          } else if (isMobile && y > lastY) {
            setState(true, false, false);
          } else if (isMobile) {
            setState(false, false, true);
          } else if (y > lastY) {
            // Desktop keeps the original directional swap.
            setState(true, false, false);
          } else {
            setState(false, true, false);
          }
          lastY = y;
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* Center search overlay with live predictive results (Shopify suggest.json). */
  /* Love Wellness–style search: full-width bar under the header + full-width
     results (count + see-all on the left, product grid on the right), page dimmed. */
  function searchOverlay(root) {
    (root || document).querySelectorAll('[data-yg-search]').forEach(function (overlay) {
      if (overlay.__ygSearch) return; overlay.__ygSearch = true;
      var input = overlay.querySelector('[data-yg-search-input]');
      var panel = overlay.querySelector('[data-yg-search-results]');
      var grid = overlay.querySelector('[data-yg-search-grid]');
      var aside = overlay.querySelector('[data-yg-search-aside]');
      var form = overlay.querySelector('.yg-search__bar');
      var openers = document.querySelectorAll('[data-yg-search-open]');
      var debounce, controller, lastReturn;

      // Move to <body> so the fixed overlay isn't clipped by the header's stacking context.
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

      /* ---- Placeholder typewriter animation ---- */
      var phrases = (overlay.getAttribute('data-yg-typewriter') || '')
        .split(/[|\n]/).map(function (x) { return x.trim(); }).filter(Boolean);
      var origPH = input ? input.getAttribute('placeholder') : '';
      var twTimer, twP = 0, twC = 0, twDel = false, twOn = false;
      // Auto-typing placeholder suggestions — no blinking cursor (plain text).
      function twStep() {
        if (!twOn || !input) return;
        var word = phrases[twP % phrases.length] || '';
        if (!twDel) {
          twC++;
          if (twC > word.length) { twDel = true; input.setAttribute('placeholder', 'Search for ' + word); twTimer = setTimeout(twStep, 1500); return; }
        } else {
          twC--;
          if (twC <= 0) { twDel = false; twP++; }
        }
        input.setAttribute('placeholder', 'Search for ' + word.slice(0, Math.max(twC, 0)));
        twTimer = setTimeout(twStep, twDel ? 40 : 80);
      }
      function twStart() { if (!input || input.value || !phrases.length) return; twOn = true; clearTimeout(twTimer); twStep(); }
      function twStop(restore) { twOn = false; clearTimeout(twTimer); if (restore && input) input.setAttribute('placeholder', origPH); }

      // Drop the bar directly below the currently visible header state. On mobile
      // the nav can be a floating pill; keep that state and measure the visible
      // wrapper instead of forcing the header back to full height.
      function positionBelowHeader() {
        var hd = document.querySelector('.yg-lw-hd');
        var isMobile = window.innerWidth <= 768;
        var target = hd && isMobile ? hd.querySelector('.yg-lw__wrap') : hd;
        var top = target ? Math.max(0, Math.round(target.getBoundingClientRect().bottom)) : 0;
        overlay.style.top = top + 'px';
        overlay.style.setProperty('--yg-search-top', top + 'px');
      }
      function showPanel(on) { if (panel) panel.hidden = !on; }

      var top = overlay.querySelector('.yg-search__top');
      function open(e) {
        if (e) e.preventDefault();
        lastReturn = e && e.currentTarget;
        overlay.hidden = false;
        document.body.classList.add('yg-search-open');
        try { positionBelowHeader(); } catch (err) { /* non-fatal: overlay is already visible */ }
        overlay.classList.add('is-open');
        // Force the panel visible with inline styles too — belt-and-braces so
        // the overlay CANNOT stay invisible even if a CSS rule (a re-linked
        // yg-home.css copy, a specificity clash from moving the overlay to
        // <body> out of its original .yg-lw scope, etc.) fails to apply the
        // .yg-search.is-open transition. Inline styles beat any stylesheet
        // rule regardless of specificity or load order. close() clears them.
        overlay.style.display = 'block';
        if (top) { top.style.transform = 'none'; top.style.opacity = '1'; }
        requestAnimationFrame(function () {
          try { positionBelowHeader(); } catch (err) { /* non-fatal: overlay is already visible */ }
        });
        // preventScroll:true — the overlay is position:fixed and the input can
        // sit below the current scroll position; a plain focus() makes the
        // browser auto-scroll the PAGE to bring the input into view, jumping
        // it to the bottom on open. preventScroll focuses without that scroll.
        setTimeout(function () { if (input) { try { input.focus({ preventScroll: true }); } catch (e2) { input.focus(); } } }, 60);
        twStart();
      }
      function close() {
        overlay.classList.remove('is-open');
        document.body.classList.remove('yg-search-open');
        // Clear the inline styles open() set, so the normal CSS (which hides
        // .yg-search[hidden] and resets .yg-search__top's transform/opacity)
        // takes over again for the close animation and the hidden end-state.
        overlay.style.display = '';
        overlay.style.top = '';
        if (top) { top.style.transform = ''; top.style.opacity = ''; }
        setTimeout(function () { overlay.hidden = true; showPanel(false); }, 300);
        twStop(true);
        if (lastReturn && lastReturn.focus) lastReturn.focus();
      }

      openers.forEach(function (btn) { btn.addEventListener('click', open); });
      overlay.querySelectorAll('[data-yg-search-close]').forEach(function (el) { el.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
      window.addEventListener('resize', function () { if (!overlay.hidden) positionBelowHeader(); });

      function money(v) {
        if (v == null || v === '') return '';
        var n = (typeof v === 'number') ? v / 100 : parseFloat(v);
        if (isNaN(n)) return (typeof v === 'string') ? v : '';
        return 'Rs. ' + Math.round(n).toLocaleString('en-US');
      }
      function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
      function stripDesc(html) {
        var d = document.createElement('div'); d.innerHTML = html || '';
        var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
        return t.length > 72 ? t.slice(0, 72).replace(/\s\S*$/, '') + '…' : t;
      }

      function cardsHtml(products) {
        return products.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = money(p.price);
          var desc = stripDesc(p.body);
          return '<a class="yg-search__card" href="' + p.url + '">'
            + '<span class="yg-search__card-media">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="yg-search__card-name">' + esc(p.title) + '</span>'
            + (desc ? '<span class="yg-search__card-desc">' + esc(desc) + '</span>' : '')
            + (price ? '<span class="yg-search__card-price">Starting at ' + price + '</span>' : '')
            + '</a>';
        }).join('');
      }

      // Fallback "you might like these" products from an editable collection (cached once).
      var fallbackCache = null;
      function loadFallback(cb) {
        if (fallbackCache) { cb(fallbackCache); return; }
        var handle = overlay.getAttribute('data-yg-fallback') || 'all';
        fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=4')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            fallbackCache = (data.products || []).map(function (p) {
              return {
                title: p.title,
                url: '/products/' + p.handle,
                image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
                price: (p.variants && p.variants[0] && p.variants[0].price) || '',
                body: p.body_html || ''
              };
            });
            cb(fallbackCache);
          })
          .catch(function () { fallbackCache = []; cb([]); });
      }

      function render(products, q) {
        var action = (form && form.getAttribute('action')) || '/search';
        var seeAll = action + '?type=product&q=' + encodeURIComponent(q);
        if (!products.length) {
          loadFallback(function (fb) {
            aside.innerHTML = '<p class="yg-search__count">No results for &ldquo;' + esc(q) + '&rdquo;</p>'
              + (fb.length ? '<p class="yg-search__suggest-line">But, you might like these.</p>' : '');
            grid.innerHTML = fb.length ? cardsHtml(fb)
              : '<p class="yg-search__empty">Try a different search — a product, ingredient or need.</p>';
            showPanel(true);
          });
          return;
        }
        aside.innerHTML = '<p class="yg-search__count">' + products.length + ' result' + (products.length > 1 ? 's' : '')
          + ' for &ldquo;' + esc(q) + '&rdquo;</p>'
          + '<a class="yg-search__seeall" href="' + seeAll + '">See all results</a>';
        grid.innerHTML = cardsHtml(products);
        showPanel(true);
      }

      function search(q) {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        aside.innerHTML = ''; grid.innerHTML = '<div class="yg-search__spinner"></div>'; showPanel(true);
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, q);
          })
          .catch(function (err) { if (err && err.name === 'AbortError') return; grid.innerHTML = '<p class="yg-search__empty">Search is unavailable right now.</p>'; showPanel(true); });
      }

      if (input) {
        input.addEventListener('input', function () {
          var q = input.value.trim();
          if (input.value.length) twStop(false); else twStart();
          clearTimeout(debounce);
          if (q.length < 2) { showPanel(false); return; }
          debounce = setTimeout(function () { search(q); }, 220);
        });
      }
    });
  }

  function init(root) { reveals(root); tabs(root); carousels(root); announceBar(root); scrollBar(root); stickyHeader(root); searchOverlay(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
